import { MapFilterForm, types } from "@vilocnv/allsetra-core";
import { FC } from "react";
import { Theme } from "@mui/material";
import { TFunction } from "i18next";
import { FormikHelpers } from "formik";
import MapLeftTop from "components/maps/Map/v1/children/MapLeftTop";

interface DashboardMapFilterProps {
  markers: types.MarkerType[];
  isFilterModalOpen: boolean;
  onFilterModalCloseClick: () => void;
  onFilterModalOpenClick: () => void;
  onFilterChange: (value: string) => void;
  onModalFormSubmit: (
    values: types.IMapFilter,
    formikHelpers: FormikHelpers<types.IMapFilter>
  ) => void;
  isLoadingGroups: boolean;
  group: any[];
  isLoadingObjectTypes: boolean;
  objectTypes: types.IObjectType[];
  isLoadingActiveAccountKeys: boolean;
  activeAccountKeys: types.IKey[];
  mapFilters: types.IMapFilter;
  theme: Theme;
  t: TFunction;
  isSelectOpen: boolean;
  setIsSelectOpen: (value: boolean) => void;
}

const DashboardMapFilter: FC<DashboardMapFilterProps> = ({
  markers,
  isFilterModalOpen,
  onFilterModalCloseClick,
  onFilterModalOpenClick,
  onFilterChange,
  onModalFormSubmit,
  group,
  objectTypes,
  activeAccountKeys,
  isLoadingGroups,
  isLoadingObjectTypes,
  isLoadingActiveAccountKeys,
  mapFilters,
  theme,
  t,
  setIsSelectOpen
}) => {
  return (
    <>
      <MapFilterForm
        open={isFilterModalOpen}
        onClose={onFilterModalCloseClick}
        onSubmit={onModalFormSubmit}
        groups={group}
        types={objectTypes}
        keys={activeAccountKeys}
        dataLoading={
          isLoadingActiveAccountKeys || isLoadingObjectTypes || isLoadingGroups
        }
        theme={theme}
        initialValues={mapFilters}
        translator={t}
        submitting={false}
      />
      <MapLeftTop
        markers={markers}
        showSearch={true}
        showFilter={true}
        onObjectChange={onFilterChange}
        onFilterClick={onFilterModalOpenClick}
        setIsSelectOpen={setIsSelectOpen}
        showCustomSearchField={false}
        isLoading={false}
      />
    </>
  );
};

export default DashboardMapFilter;
